import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useTenant } from './Common/Contexts/TenantContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import WebsiteManager from './WebsiteManager';
import WebsiteVisualizer from './WebsiteVisualizer';

// Lazy loading the corporate templates
const Template_1 = lazy(() => import('./Templates/Template_1'));
const Template_2 = lazy(() => import('./Templates/Template_2'));
const Template_3 = lazy(() => import('./Templates/Template_3'));

const templateMap = {
  Template_1,
  Template_2,
  Template_3,
};

function App() {
  const { tenantData, loading } = useTenant();

  // 1. Loading State with corporate specific text
  if (loading) return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="text-center">
        <div className="spinner-border text-primary" role="status"></div>
        <div className="mt-2 text-secondary small">Identifying Corporate Portal...</div>
      </div>
    </div>
  );

  const ref = tenantData?.templateReference;
  const ActiveTemplate = templateMap[ref];

  // 2. Strict Logic: If no template is found in the map, display a blank setup page

  return (
    <>
      <Routes>
        {/* ⭐ ADMIN ROUTE: This is available on all domains */}
         <Route path="/admin/website-manager" element={<WebsiteManager />} />
        <Route path="/admin/website-visualizer" element={<WebsiteVisualizer />} />

        {/* ⭐ PUBLIC WEBSITE ROUTE */}
        <Route path="*" element={
          !ActiveTemplate ? (
            /* Website Not Configured Screen */
            <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
              <div className="text-center p-5 shadow-sm bg-white rounded-4" style={{ maxWidth: '400px' }}>
                <h1 className="display-4 text-muted mb-3">404</h1>
          <h5 className="fw-bold">Corporate Portal Not Configured</h5>
          <p className="text-secondary small">
            This domain is not currently associated with an active corporate travel portal. 
            Please setup your template from the administration dashboard.
          </p>
          <hr />
          <small className="text-muted">© 2026 Smart Travel B2E Platform</small>
              </div>
            </div>
          ) : (
            /* Dynamically Loaded Template */
            <Suspense fallback={<div className="text-center p-5">Loading Website...</div>}>
              <ActiveTemplate />
            </Suspense>
          )
        } />
      </Routes>

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default App;